<template>
  <b-modal
    title="Thêm hồ sơ cán bộ"
    size="lg"
    ref="themThongTinCanBoModal"
    hide-footer
    centered
  >
    <div id="thong-tin-can-bo-user">
      <validation-observer ref="obCanBo">
        <b-form class="font-size-14">
          <b-row>
            <b-col cols="6">
              <ValidationProvider
                name="Tên cán bộ"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group label="Họ và tên" class="required">
                  <b-form-input
                    :state="getValidationState(validationContext)"
                    id="hoTen"
                    v-model="form.hoTen"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="6">
              <ValidationProvider
                name="Mã cán bộ"
                rules="required|code|hashcode"
                v-slot="validationContext"
              >
                <b-form-group label="Mã cán bộ" class="required">
                  <b-form-input
                    :state="getValidationState(validationContext)"
                    id="hoTen"
                    v-model="form.maCanBo"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Ngày sinh"
                label-for="ngaySinh"
                class="required"
              >
                <ValidationProvider rules="required">
                  <div slot-scope="{ errors }">
                    <date-picker
                      required
                      :class="{ 'is-danger': errors.length > 0 }"
                      format="DD/MM/YYYY"
                      value-type="format"
                      type="day"
                      v-model="ngaySinhFormatted"
                      class="custom-datepicker"
                      placeholder="Chọn ngày"
                      :disabled-date="(e) => minDate(e)"
                    ></date-picker>
                    <p
                      :class="{ error: errors.length > 0 }"
                      v-if="errors.length"
                    >
                      {{ errors.length > 0 ? "Vui lòng chọn ngày sinh" : "" }}
                    </p>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <ValidationProvider rules="required">
                <div slot-scope="{ errors }">
                  <b-form-group label="Giới tính" class="required">
                    <v-select
                      ref="gioiTinh"
                      :multiple="false"
                      v-model="form.gioiTinh"
                      :options="optionsGender"
                      required
                      :reduce="(name) => name.value"
                      title="Chọn giới tính"
                      placeholder="Chọn giới tính"
                      :class="{ 'is-danger-custom': errors.length > 0 }"
                    >
                    </v-select>
                  </b-form-group>
                  <p
                    style="margin-top: -10px"
                    :class="{ error: errors.length > 0 }"
                  >
                    {{ errors.length > 0 ? "Vui lòng chọn giới tính" : "" }}
                  </p>
                </div>
              </ValidationProvider>
            </b-col>

            <b-col cols="12">
              <ValidationProvider
                name="Địa chỉ liên hệ"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group label="Địa chỉ liên hệ" class="required">
                  <b-form-input
                    :state="getValidationState(validationContext)"
                    id="hoTen"
                    v-model="form.diaChi"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col cols="12">
              <span class="float-left mr-3 mt-1">Đơn vị</span
              ><base-button
                @click="themDonVi"
                class="float-left"
                icon="none"
                color="btn-primary"
                button="Thêm mới"
              />
            </b-col>
            <b-col cols="12">
              <p class="error" v-if="errorDonVi">Bạn chưa chọn đơn vị</p>
              <DataTable
                :value="danhSachDonViChucVuNoiBo"
                class="p-datatable-customers mt-2"
                dataKey="Id"
                :paginator="false"
                v-if="isShowCanBoTable"
                :auto-layout="true"
              >
                <template #empty
                  ><div class="text-center">Không có dữ liệu</div></template
                >
                <template #loading>Đang tải dữ liệu ...</template>
                <Column
                  v-for="(col, index) in MANG_DON_VI_FIELDS"
                  :key="index"
                  :field="col.field"
                  :header="col.header"
                  :header-class="col.headerClass"
                  :body-class="col.bodyClass"
                >
                  <template #filter>
                    <InputText
                      v-if="col.keySearch"
                      type="text"
                      class="p-column-filter"
                      placeholder="Tìm kiếm"
                      v-model="form[col.keySearch]"
                      @change="searchTable"
                    />
                  </template>
                  <template v-if="col.field === 'Stt'" #body="slotProps">
                    {{ slotProps.index + 1 }}
                  </template>
                  <template v-else-if="col.field === 'donVi'" #body="slotProps">
                    {{ slotProps.data.donVi && slotProps.data.donVi.label }}
                  </template>
                  <template
                    v-else-if="col.field === 'chucVu'"
                    #body="slotProps"
                  >
                    {{ slotProps.data.chucVu.chucVu }}
                  </template>
                  <template
                    v-else-if="col.field === 'trangThai'"
                    #body="slotProps"
                  >
                    {{ slotProps.data.trangThai.name }}
                  </template>
                  <template
                    v-else-if="col.field === 'macDinh'"
                    #body="slotProps"
                  >
                    <b-form-checkbox
                      class="text-center cursor-pointer"
                      :checked="slotProps.data.macDinh"
                      switch
                      @change="
                        changeSwitch(slotProps.data.macDinh, slotProps.index)
                      "
                      v-model="slotProps.data.macDinh"
                    ></b-form-checkbox>
                  </template>
                  <template
                    v-else-if="col.field === 'thaoTac'"
                    #body="slotProps"
                  >
                    <b-icon
                      icon="pencil-square"
                      class="cursor-pointer mr-2"
                      @click="onEditDonVi(slotProps.data, slotProps.index)"
                    />
                    <b-icon
                      icon="trash"
                      class="cursor-pointer"
                      @click="
                        openModalConfirm(
                          slotProps.index,
                          1,
                          slotProps.data.donVi.label
                        )
                      "
                    />
                  </template>
                </Column>
              </DataTable>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <div class="d-flex justify-content-end mt-3">
        <base-button button="Lưu" @click="submitForm()"> </base-button>
        <base-button button="Đóng" @click="hideModal()"></base-button>
      </div>
      <ModalThemThongTinDonVi
        ref="ModalThemThongTinDonVi"
        :danhSachDonViBanDau="danhSachDonViBanDau"
        :data="dataDonVi"
        :disabledFields="['trang-thai']"
        :normalizer="normalizer"
        @onSave="themDonViItem"
        @onEdit="suaDonViItem"
      />
      <ModalConfirm
        ref="ModalConfirm"
        :name="labelDelete"
        @onDelete="onDelete"
      />
    </div>
  </b-modal>
</template>
<script>
import { isNil, pickBy } from "lodash";
import ModalConfirm from "@/components/pages/quan-ly-danh-muc/don-vi/ModalConfirm";
import { removeAccents } from "@/utils/normalize";
import { MANG_DON_VI_FIELDS } from "@/constants/donVi";
import { mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import ModalThemThongTinDonVi from "@/components/pages/quan-ly-danh-muc/don-vi/ModalThemThongTinDonVi";
import "vue2-datepicker/index.css";
import _isEmpty from "lodash/isEmpty";
import _cloneDeep from "lodash/cloneDeep";
const defaultForm = {
  donViList: [],
  thongTinTaiKhoan: [],
  userId: null,
  tinhThanh: null,
  quanHuyen: null,
  phuongXa: null,
  maCanBo: "",
  hoTen: "",
  phone_DiDong: "",
  phone_CoQuan: "",
  phone_NhaRieng: "",
  email: "",
  gioiTinh: null,
  ngaySinh: null,
  iD_ChucVu: null,
  userName: "",
  iD_DonVi: null,
  iD_DonVi_HoatDong: null,
  iD_DonVi_BietPhai: null,
  cmtnd: "",
  diaChi: "",
  bit_ChuyenCongTac: false,
  bit_NhanTinBuon_Email: false,
  bit_NhanTinBuon_SMS: false,
  bit_DanhBa: false,
  bit_ThuTruongDonVi: false,
  bitDauMoiPAKN: false,
  anhDaiDien_FilePath: "",
  anhChuKy_FilePath: "",
  anhChuKyNhay_FilePath: "",
  thuTu: null,
};
export default {
  name: "ThemThongTinCanBoModal",
  data() {
    return {
      MANG_DON_VI_FIELDS,
      isShowCanBoTable: false,
      ngaySinhFormatted: null,
      optionsGender: [
        { label: "Nữ", value: false },
        { label: "Nam", value: true },
      ],
      form: _cloneDeep(defaultForm),
      dataDonVi: null,
      errorDonVi: false,
      labelDelete: "",
      danhSachDonViChucVuNoiBo: [],
    };
  },
  components: { DatePicker, ModalThemThongTinDonVi, ModalConfirm },
  computed: {
    ...mapGetters({
      danhSachChucVu: "chucVu/danhSachChucVu",
      danhSachDonVi: "donVi/danhSachDonVi",
    }),
    danhSachDonViBanDau() {
      if (!this.danhSachDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachDonVi.map((item) => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          Label: item.tenDonVi,
          Childrens: [],
          ...item,
        };
      });
      return this.list_to_tree(danhSach);
    },
  },
  created() {},
  watch: {
    "form.donViList": {
      handler() {
        this.danhSachDonViChucVuNoiBo = this.form.donViList;
      },
      deep: true,
    },
  },
  methods: {
    showModal() {
      this.errorDonVi = false;
      this.form = _cloneDeep(defaultForm);
      this.$refs["themThongTinCanBoModal"].show();
    },
    hideModal() {
      this.$refs["themThongTinCanBoModal"].hide();
    },
    openModalConfirm(index, type, label) {
      this.labelDelete = label;
      this.indexSua = index;
      this.typeXoa = type;
      this.$refs["ModalConfirm"].$refs.confirm.show();
    },
    async onDelete() {
      await this.form.donViList.splice(this.indexSua, 1);
    },
    changeSwitch(data, index) {
      if (!data) this.resetMacDinhDonVi(index);
    },
    filterList(list) {
      return list.filter((key) => !key.isHide);
    },
    normalizer(node) {
      return {
        children: _isEmpty(node.children) ? undefined : node.children,
      };
    },
    minDate(e) {
      let date = new Date("1900-01-01");
      return e < moment(date).toDate();
    },
    themDonVi() {
      this.dataDonVi = null;
      this.$refs["ModalThemThongTinDonVi"].$refs.ThongTinDonVi.show();
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetMacDinhDonVi(index) {
      this.form.donViList.forEach((item) => {
        item.macDinh = false;
      });
      this.form.donViList[index].macDinh = true;
    },
    themDonViItem(data) {
      this.errorDonVi = false;
      this.isShowCanBoTable = false;
      this.form.donViList.push(data);
      if (data.macDinh) this.resetMacDinhDonVi(this.form.donViList.length - 1);
      this.$refs["ModalThemThongTinDonVi"].hideModal();
      this.isShowCanBoTable = true;
    },
    suaDonViItem(data) {
      this.errorDonVi = false;
      this.isShowCanBoTable = false;
      this.form.donViList[this.indexSua] = data;
      if (data.macDinh) this.resetMacDinhDonVi(this.indexSua);
      this.$refs["ModalThemThongTinDonVi"].hideModal();
      this.isShowCanBoTable = true;
    },
    onEditDonVi(data, index) {
      this.dataDonVi = data;
      this.indexSua = index;
      this.$refs["ModalThemThongTinDonVi"].$refs.ThongTinDonVi.show();
    },
    list_to_tree(list) {
      if (list.length > 0) {
        var map = {},
          node,
          roots = [],
          i;
        for (i = 0; i < list.length; i += 1) {
          map[list[i].Task_ID] = i; // initialize the map
          list[i].Childrens = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.Task_Parent_ID !== this.guidEmpty) {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.Task_Parent_ID]] != null) {
              list[map[node.Task_Parent_ID]].Childrens.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            } else {
              roots.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            }
          } else {
            roots.push({
              id: node.Task_ID,
              label: node.Label,
              parentId: node.Task_Parent_ID,
              children: node.Childrens,
            });
          }
        }
        return roots;
      }
      return list;
    },
    removeAccents(string, upperCase = false) {
      return removeAccents(string, upperCase);
    },
    searchTable() {
      let result = [];
      if (_isEmpty(this.form.donViList) || !this.form.donViList) {
        result = [];
      } else {
        result = this.form.donViList;
      }
      if (this.form.donVi !== "") {
        result = this.form.donViList.filter((x) =>
          removeAccents(x.donVi.label)
            .toLowerCase()
            .includes(removeAccents(this.form.donVi).toLowerCase())
        );
      }
      if (this.form.chucVu !== "") {
        result = this.form.donViList.filter((x) =>
          removeAccents(x.chucVu.chucVu)
            .toLowerCase()
            .includes(removeAccents(this.form.chucVu).toLowerCase())
        );
      }
      if (this.form.trangThai !== "") {
        result = this.form.donViList.filter((x) =>
          removeAccents(x.trangThai.name)
            .toLowerCase()
            .includes(removeAccents(this.form.trangThai).toLowerCase())
        );
      }
      this.danhSachDonViChucVuNoiBo = result;
    },
    convertStringToDateTime(stringDate) {
      if (stringDate) {
        const strDate = stringDate.split("/");
        return `${strDate[2]}-${strDate[1]}-${strDate[0]}`;
      }
    },
    getPayload() {
      let departments = [];
      this.form.donViList.forEach((item) => {
        departments.push({
          chucVuId: item.chucVu.id,
          tenChucVu: item.chucVu.chucVu,
          tenChucVuKhongDau: this.removeAccents(item.chucVu.chucVu),
          donViId: (item.donVi || {}).id,
          tenDonVi: (item.donVi || {}).label,
          tenDonViKhongDau: this.removeAccents(item.donVi.label),
          trangThai: item.trangThai.id ? 1 : 0,
          isDefault: item.macDinh,
        });
      });
      let userAccounts = [];
      this.form.thongTinTaiKhoan.forEach((item) => {
        let application = [];
        item.ungDung.forEach((i) => {
          application.push({
            applicationName: i.name,
            applicationNameKhongDau: this.removeAccents(i.name),
            applicationId: i.id,
          });
        });
        userAccounts.push({
          id: item.tenDangNhap.id || null,
          userId: item.tenDangNhap.userId,
          username: item.tenDangNhap.userName,
          applications: application,
          password: item.matKhau,
          trangThai: item.trangThai.id ? 1 : 0,
        });
      });
      return {
        id: null,
        maCanBo: this.form.maCanBo,
        hoTen: this.form.hoTen,
        phone_DiDong: this.form.phone_DiDong,
        phone_CoQuan: this.form.phone_CoQuan,
        phone_NhaRieng: this.form.phone_NhaRieng,
        email: this.form.email,
        gioiTinh: this.form.gioiTinh,
        ngaySinh: moment(
          new Date(this.convertStringToDateTime(this.ngaySinhFormatted))
        ).toISOString(),
        iD_ChucVu: null,
        userName: "",
        iD_DonVi: null,
        iD_DonVi_HoatDong: null,
        iD_DonVi_BietPhai: null,
        cmtnd: this.form.cmtnd,
        bit_NhanTinBuon_Email: this.form.bit_NhanTinBuon_Email,
        bit_NhanTinBuon_SMS: this.form.bit_NhanTinBuon_SMS,
        bit_ThuTruongDonVi: this.form.bit_ThuTruongDonVi,
        diaChi: this.form.diaChi,
        userId: null,
        thuTu: this.form.thuTu,
        tinhId: this.form.tinhThanh,
        huyenId: this.form.quanHuyen,
        xaId: this.form.phuongXa,
        userAccounts: userAccounts,
        departments: departments,
      };
    },
    async submitForm() {
      let isValid = await this.$refs.obCanBo.validate();
      if (!this.form.donViList || this.form.donViList.length === 0) {
        this.errorDonVi = true;
      }
      if (!isValid || this.errorDonVi) {
        return;
      }
      let payload = this.getPayload();
      let data = payload;
      data = pickBy(data, function (value) {
        return !isNil(value);
      });
      data.thuTu = parseInt(this.form.thuTu || 0);
      await this.$store.dispatch("canBo/taoCanBo", {
        data: data,
        onSuccess: this.onSuccess,
      });
    },
    onSuccess(response) {
      this.hideModal();
      let canBo = {
        id: response.data,
        hoTen: this.form.hoTen,
      };
      this.$emit("pushCanBoToForm", canBo);
    },
  },
};
</script>
<style lang="scss">
#thong-tin-can-bo-user {
  .mx-datepicker.is-danger {
    :focus {
      border-color: #dc3545;
      box-shadow: 0 0 0 0.2rem rgb(220 53 69 / 25%);
    }
    input {
      border: 1px solid #e42020;
    }
  }
  .error {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    margin-bottom: 0;
  }
  .mx-datepicker {
    width: 100% !important;
    .mx-input {
      border-radius: 3px !important;
    }
  }
  .is-danger-custom {
    border: 1px solid red;
    border-radius: 3px;
  }
}
</style>